var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"edit-button",on:{"click":_vm.onClick}},[_vm._t("icon",[_c('i',{class:("fas fa-" + _vm.icon)})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }